jQuery(document).ready( function() {
	const vivaPopup = jQuery('.viva-newsletter-popup');
	const vivaPopupForm = jQuery('form', vivaPopup);
	const vivaPopupClose = jQuery('.viva-newsletter-popup__close');
	const vivaPopupCookie = {"name": "VivaNewsletterDelay"};

	// Show popup if cookie doesn't exist or has expired.
	if ( Cookies.get( vivaPopupCookie.name ) === undefined ) {
		function showPopup() {
			setTimeout(function () {
				if ( jQuery('#age-verification').is(':visible') || jQuery('.dialog-age-verification').is(':visible') ) {
					showPopup();
				} else {
					vivaPopup.addClass('viva-newsletter-popup--visible');
				}
			}, 7000);
		}
		showPopup();	
	}

	// Handle popup close.
	jQuery(vivaPopupClose).bind('click', function() {
		vivaPopup.hide();
		Cookies.set( vivaPopupCookie.name, 'true', { expires: 7 } );
	});

	// Handle popup form submit.
	jQuery(vivaPopupForm).submit(function(event) {

		event.preventDefault();

		const vivaPopupConfirmation = jQuery('.viva-newsletter-popup__confirmation');
		const terms = vivaPopupForm.find('input[name=terms]');
		const email = vivaPopupForm.find('input[name=email]');
		const submit = vivaPopupForm.find('input[type=submit]');
		let emailIsValid = isValidEmailAddress( email.val() );

		if ( terms.is(':not(:checked)') && emailIsValid === false) {
			alert( 'Du måste ange din e-postadress och godkänna hanteringen av dina personuppgifter.' );
			email.focus();
			return;
		} else if ( terms.is(':not(:checked)') ) {
			alert( 'Du måste godkänna hanteringen av dina personuppgifter.' );
			terms.focus();
			return;
		} else if ( emailIsValid === false ) {
			alert( 'Du måste ange en korrekt e-postadress.' );
			email.focus();
			return;
		}

		// Indicate form is being submitted and disable submit button.
		vivaPopupForm.css('opacity', '0.5');
		submit.prop('disabled', true);

		jQuery.ajax({
			cache: false,
			headers: { "cache-control": "no-cache" },
			type: "POST",
			url: vivaPopupForm.attr('action'),
			dataType: "json",
			data: vivaPopupForm.serialize()
		}).done(function(response) {
			vivaPopupForm.hide();
			vivaPopupConfirmation.show();
			Cookies.set( vivaPopupCookie.name, 'true', { expires: 365 } );

			// Hide popup after 10s.
			setTimeout(
				function() {
					vivaPopup.hide();
				},
				10000
			);

		}).fail(function(response) {
			alert( 'Ett fel inträffade och det gick tyvärr inte att registrera dig. Vänligen försök igen senare.' );
			vivaPopupForm.css('opacity', '1');
			submit.prop('disabled', false);
		});
	});

	// Email validation.
	function isValidEmailAddress(emailAddress) {
		var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
		return pattern.test(emailAddress);
	};
});